export const EntityLayerFragment = gql`
  fragment EntityLayerFragment on EntityLayer {
    id
    uuid
    name
    type
  }
`
